export default "__VITE_ASSET__AKEpvSZ5__"